<template lang="pug">
  b-container(fluid)
    b-row
      b-col.page-wrap(cols="12")
        div(slot="header").d-flex.justify-content-between.page-header.flex-column
          b-container.d-flex.justify-content-between(fluid)
            div
              span.page-title {{$t('remote.remote.title')}} {{$t('statistics')}}
              b-button(variant="link", size="sm", style="padding: 0.25rem 0.7rem;", target="_blank", href="https://linkmemine.co.kr/faq/p/manager_guide_topic_07.php")
                //icon(name="bookmark", style="margin:0 4px 0 2px;")
                span {{$t('tutorial-statistics')}}

            div
              b-button.mr-1(
                size="sm",
                :class="{active: query.type === 'monthly'}",
                @click="setMonthly") {{$t('by_monthly')}}
              b-button.mr-1(
                size="sm",
                :class="{active: query.type === 'daily'}",
                @click="setDaily") {{$t('by_daily')}}
              datepicker(
                class="hidden-picker",
                ref="datepicker",
                :value="query.date",
                :minimumView="picker.min",
                :maximumView="picker.max",
                :bootstrap-styling="true",
                format="yyyy-MM-dd",
                :language="picker.lang",
                @selected="dateChanged")
              b-button(size="sm", @click="showDatepicker")
                span {{$t('select_date')}}: {{query.string}}

        //b-row
        //  b-col(cols="6").pr-3
        //    b-card(no-body)
        //      div(slot="header") {{$t('connect_count_of_remote')}}
        //      b-table(
        //        :fields="fields",
        //        :items="items")
        //        template(slot="HEAD_start_date", slot-scope="data")
        //          | {{$t('date')}}
        //        template(slot="HEAD_access_cnt", slot-scope="data")
        //          | {{$t('use_count')}}
        //        template(slot="HEAD_access_ratio_string", slot-scope="data")
        //          | {{$t('rate')}}
        //  b-col(cols="6").pl-3
        //    b-card(v-if="ready")
        //      div(slot="header") {{$t('chart')}}
        //      bar-chart(:chart-data="chartData", :options="chartOptions", style="height: 40rem")

        b-row
          b-col(cols="12")
            b-card.char-card(v-if="ready")
              div(slot="header") {{$t('chart')}}
              bar-chart(:chart-data="chartData", :options="chartOptions")
        b-row.mt-3
          b-col(cols="12")
            b-card(no-body)
              div(slot="header") {{$t('connect_count_of_remote')}}
              b-table(
                :fields="fields",
                :items="items")
                template(slot="HEAD_start_date", slot-scope="data")
                  | {{$t('date')}}
                template(slot="HEAD_access_cnt", slot-scope="data")
                  | {{$t('use_count')}}
                template(slot="HEAD_access_ratio_string", slot-scope="data")
                  | {{$t('rate')}}

</template>

<script>
import _ from 'lodash'
import {getCurrentLanguage} from '@/i18n'
import * as datePickerLocale from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
import BarChart from './bar-chart'
import {AnalysticAPI} from '../../api'

const padd = (n) => {
  let ns = n.toString()
  if (ns.length === 1) ns = '0' + ns
  return ns
}

export default {
  name: 'rate-remote-component',
  components: { BarChart, Datepicker },
  methods: {
    setMonthly () {
      let date = this.query.date
      this.query.type = 'monthly'
      this.query.year = date.getFullYear()
      this.query.string = this.query.year.toString()
      this.query.prefix = this.query.string + '-'

      this.picker.min = 'year'
      this.picker.max = 'year'
      this.getData()
    },
    setDaily () {
      let date = this.query.date
      this.query.type = 'daily'
      this.query.year = date.getFullYear()
      this.query.month = date.getMonth() + 1
      this.query.string = this.query.year + '-' + padd(this.query.month)
      this.query.prefix = this.query.string + '-'

      this.picker.min = 'month'
      this.picker.max = 'year'
      this.getData()
    },
    showDatepicker () {
      this.$refs.datepicker.showCalendar()
    },
    dateChanged (date) {
      this.query.date = date
      if (this.query.type === 'monthly') {
        this.query.year = date.getFullYear()
        this.query.string = this.query.year.toString()
        this.query.prefix = this.query.string + '-'
      } else if (this.query.type === 'daily') {
        this.query.year = date.getFullYear()
        this.query.month = date.getMonth() + 1
        this.query.string = this.query.year + '-' + padd(this.query.month)
        this.query.prefix = this.query.string + '-'
      }
      this.getData()
    },
    getData () {
      let params = {
        type: this.query.type,
        year: this.query.year,
        month: this.query.month
      }
      AnalysticAPI.chart.get('remote', {params})
        .then(resp => {
          let apiData = resp.data.objects

          // 전체 기간 데이터 생성 후 API 응답 병합 (빈 시간대 보정)
          let data = this.fillEmptyPeriods(apiData)

          // 포맷팅
          data = _.map(data, v => {
            v.access_ratio_string = (v.access_ratio || 0).toFixed(2) + ' %'
            return v
          })
          this.items = data
          this.chartData = {
            labels: _.map(data, (v, i) => (i + 1).toString()),
            datasets: [
              {
                label: this.$t('connect_count_of_remote'),
                backgroundColor: '#C1C1C1',
                data: _.map(data, v => v.access_cnt)
              }
            ]
          }
          this.ready = true
        })
    },
    fillEmptyPeriods(apiData) {
      const count = this.query.type === 'monthly' ? 12 : new Date(this.query.year, this.query.month, 0).getDate()

      // API 데이터를 value_date 기준으로 맵핑
      const dataMap = {}
      apiData.forEach(item => {
        const key = parseInt(item.value_date, 10)
        dataMap[key] = item
      })

      // 전체 기간 데이터 생성 (1~12월 또는 1~말일)
      return _.range(1, count + 1).map(i => {
        if (dataMap[i]) {
          return dataMap[i]
        }
        return {
          pk: null,
          start_date: this.query.prefix + padd(i),
          value_date: padd(i),
          access_cnt: 0,
          access_ratio: 0,
        }
      })
    }
  },
  created () {
    const now = new Date()
    this.query.type = 'monthly'
    this.query.year = now.getFullYear()
    this.query.month = now.getMonth() + 1
    this.query.date = now
    this.query.string = this.query.year.toString()
    this.query.prefix = this.query.string + '-'
  },
  mounted () {
    this.getData()
  },
  data () {
    return {
      ready: false,
      query: {},
      picker: {
        min: 'year',
        max: 'year',
        lang: datePickerLocale[getCurrentLanguage()]
      },
      fields: [
        { key: 'start_date', label: this.$t('date') },
        { key: 'access_cnt', label: this.$t('use_count') },
        { key: 'access_ratio_string', label: this.$t('rate') }
      ],
      items: [],
      chartData: null,
      chartOptions: {
        legend: { display: false },
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              suggestedMin: 0,
              suggestedMax: 50,
            }
          }]
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
  margin: 0;
}

.row, .col, .container-fluid, .container, .col-12, .col-6 {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
  > .card-header {
    border-bottom: 1px solid #D2D2D2;
    font-size: 0.9rem;
    font-weight: 500;
  }
}
::v-deep .b-table {
  margin: 0;
  tr, td, th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  th:nth-child(1), th:nth-child(2) {
    position: relative;
    padding-right: 0;
  }

}

.btn-secondary {
  color: black !important;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}


::v-deep .form-control {
  border: 1px solid #6F6F6F;
  height: 1.7rem;
  &:disabled,
  &[readonly] {
    background-color: #FFFFFF;
  }
}

#bar-chart {
  width: 90%;
  height: 90%;
}

//.container-fluid, .btn-link {
//  padding: 0;
//}
//
//.header-div {
//  padding: 1.5rem 1.5rem 0.5rem 2.5rem;
//  background-color: rgba(0, 0, 0, 0.07);
//  margin-bottom: 1.5rem;
//  border-bottom: 2px rgba(0, 0, 0, 0.1);
//  .title {
//    font-size: 1.3rem;
//    font-weight: bold;
//  }
//  .col-12 {
//    margin-top: 1rem;
//  }
//}
</style>
